import { Routes } from '@angular/router';

import { verifyGuard } from '@flashy/auth/feature';
import { AuthGuard } from '@guards/auth/auth.guard';
import { dashGuardFn } from '@guards/dash/dash.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'dash',
    loadChildren: () => import('./pages/choose-account/choose-account.routes'),
    canActivate: [AuthGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.routes'),
    canMatch: [dashGuardFn],
  },
  {
    path: 'verify',
    loadComponent: async () =>
      (await import('@flashy/auth/shell')).VerifyShellComponent,
    canActivate: [verifyGuard],
  },
  {
    path: 'oauth',
    loadChildren: () => import('./pages/o-auth/oauth.routes'),
    canActivate: [AuthGuard],
  },
  {
    path: 'connect/:app',
    loadChildren: () => import('./pages/connect/connect.routes'),
  },
  {
    path: '505',
    loadComponent: () => import('./pages/forbidden/forbidden.component'),
  },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found.component'),
  },
];

export default routes;
